"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Logger = exports.Log = void 0;
var Log;
(function (Log) {
    Log[Log["OFF"] = 0] = "OFF";
    Log[Log["ALL"] = 1] = "ALL";
    Log[Log["DEBUG"] = 2] = "DEBUG";
    Log[Log["INFO"] = 3] = "INFO";
    Log[Log["WARN"] = 4] = "WARN";
    Log[Log["ERROR"] = 5] = "ERROR";
    Log[Log["FATAL"] = 6] = "FATAL";
})(Log = exports.Log || (exports.Log = {}));
class Logger {
    constructor(tag, level = Log.ALL, context = null) {
        this.tag = tag;
        this.level = level;
        this.context = context;
        this._tagStyle = {
            base: {
                color: '#333',
                background: '#E0E0E0',
                padding: '0 .5em',
                'border-radius': '1em',
                'font-size': '1em',
                width: '64px',
            },
            [Log.DEBUG]: {
                color: '#555',
                'font-style': 'italic',
            },
            [Log.ERROR]: {
                background: '#F33',
                color: '#FFFF',
                'font-weight': 'bold',
            },
            [Log.FATAL]: {
                background: '#F00',
                color: '#FFFF',
                'font-weight': 'bold',
                'text-decoration': 'underline',
            },
            [Log.INFO]: {
                background: '#08D',
                color: '#FFFF',
                'font-weight': 'bold',
            },
            [Log.WARN]: {
                background: '#FA0',
                color: '#000',
                'font-weight': 'bold',
            },
        };
        this._logLevelsNames = {
            [Log.DEBUG]: 'debug',
            [Log.ERROR]: 'error',
            [Log.FATAL]: 'fatal',
            [Log.INFO]: 'info',
            [Log.WARN]: 'warning',
        };
    }
    debug(...args) {
        return this.log(Log.DEBUG, ...args);
    }
    info(...args) {
        return this.log(Log.INFO, ...args);
    }
    warn(...args) {
        return this.log(Log.WARN, ...args);
    }
    error(...args) {
        return this.log(Log.ERROR, ...args);
    }
    fatal(...args) {
        this.log(Log.FATAL, ...args);
        throw new Error(args[0]);
    }
    log(level, ...args) {
        return this.writeLog(level, this.tag, ...args);
    }
    writeLog(level = 1, context, ...messages) {
        if (Array.isArray(this.context) && !this.context.includes(context))
            return this;
        if (this.level === Log.OFF || level < this.level)
            return this;
        const levelName = this._logLevelsNames[level];
        const levelStyle = getTagStyle(this._tagStyle, level);
        console.log(`%c${context}: ${levelName}`, levelStyle, ...messages);
    }
    create(context) {
        const contextItems = this.level === Log.OFF ? [] : this.context;
        return new Logger(context, this.level, contextItems);
    }
}
exports.Logger = Logger;
function getTagStyle(styles, level) {
    const style = Object.assign({}, styles.base, styles[level]);
    let str = '';
    for (let prop in style) {
        str += `${prop}:${style[prop]};`;
    }
    return str;
}
